import { BlockViewExtension } from '@blocksuite/hive/std';
import type { ExtensionType } from '@blocksuite/hive/store';
import { literal } from 'lit/static-html.js';

export const AIChatBlockSpec: ExtensionType[] = [
  BlockViewExtension('hive:embed-ai-chat', model => {
    const parent = model.doc.getParent(model.id);

    if (parent?.flavour === 'hive:surface') {
      return literal`hive-edgeless-ai-chat`;
    }

    return literal`hive-ai-chat`;
  }),
];
